module.exports = __webpack_public_path__ + "static/media/PratDecPed-ensinoInf-curto.c356c548.png";